import { useEffect, useState } from "react";
import { PageHero, Container } from "../components/Section";
import { api, API } from "../lib/api";
import { Music as MusicIcon } from "lucide-react";

const CHOIR_IMG = "https://images.unsplash.com/photo-1519937754318-2462db1c429d?crop=entropy&cs=srgb&fm=jpg&q=85";

export default function Music() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/media?category=music").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="music-page">
      <PageHero
        overline="Music Ministry"
        title={<>Lift every <em className="text-gold-light italic font-light">voice</em>.</>}
        kicker="Mass Choir, Male Chorus, Praise Team, Youth Choir, Dance, Mime — together we make a joyful noise unto the Lord."
        image="/images/branding/pastor-worship.jpg"
      />

      <Container className="pb-32">
        <div className="grid lg:grid-cols-2 gap-10 mb-16">
          <img src={CHOIR_IMG} alt="Choir" className="w-full h-[460px] object-cover grayscale-[0.4]" />
          <div className="flex flex-col justify-center">
            <h2 className="font-serif text-4xl md:text-5xl font-black mb-6">A Sound Forged in <em className="text-gold-light italic font-light">Worship</em>.</h2>
            <p className="text-white/75 leading-relaxed text-lg">
              From the rich harmonies of our Mass Choir to the contemporary fire of our Praise Team, the music of Sixth Mount Zion has been the heartbeat of our worship for generations. Whether you sing, play, dance, or simply lift your hands — there is a place for you in our music ministry.
            </p>
            <ul className="mt-8 space-y-3 text-white/80">
              {["Mass Choir", "Male Chorus", "Praise Team", "Inspirational Choir", "Youth Choir", "Dance Ministry", "Mime Ministry"].map((c) => (
                <li key={c} className="flex items-center gap-3"><MusicIcon className="h-4 w-4 text-gold" /> {c}</li>
              ))}
            </ul>
          </div>
        </div>

        {items.length > 0 && (
          <>
            <h3 className="font-serif text-3xl font-bold mb-8 mt-20">Latest Recordings</h3>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {items.map((m) => (
                <div key={m.id} className="glass p-6">
                  <div className="text-xs uppercase tracking-widest text-gold mb-2">{m.series || "Music"}</div>
                  <h4 className="font-serif text-lg font-bold mb-3">{m.title}</h4>
                  <audio controls className="w-full">
                    <source src={`${API}/media/file/${m.id}`} type={m.content_type} />
                  </audio>
                </div>
              ))}
            </div>
          </>
        )}
      </Container>
    </div>
  );
}
